import React, { useState } from "react";
import { useSelector } from "react-redux";

import { get, isObject } from "lodash";
import { ArticleButton } from "../Helper";
import { formatDate } from "../../../helpers/date";
import RelatedList from "./RelatedList";
import Title from "../../../components/Title";
import Editor from "../../../components/Editor";
import Spinner from "../../../components/Spinner";
import AsyncGet from "../../../components/AsyncGet";
import ReadTime from "../../../components/ReadTime";
import IconLabel from "../../../components/IconLabel";
import Background from "../../../components/Background";
import ArticleSave from "../../../components/ArticleSave";
import CategoryList from "../../../components/CategoryList";

import style from "./style.module.css";

export default function Popup({ articleUrl }) {
    const userProfile = useSelector((state) => state.storage.data);
    const [showAdditonalResources, setShowAdditonalResources] = useState(false);
    return (
        <AsyncGet
            url={articleUrl}
            loadOnMount={true}
            render={({ data, fetching }) => {
                if (fetching === true) {
                    return (
                        <div className={style.spinner}>
                            <Spinner />
                        </div>
                    )
                }
                else if (fetching === false && isObject(data)) {
                    const {
                        publish_date = "",
                        thumbnail_image,
                        author_name = "",
                        themes = [],
                        categories = [],
                        tags = [],
                        url = "",
                        time_duration = ""
                    } = data;
                    return (
                        <div className={`${style.popupArea}`}>
                            <div className={style.articlePopupBanner}>
                                <div className={style.imageWrap}>
                                    <Background src={thumbnail_image} size="680x380" />
                                </div>
                            </div>
                            <div className={style.articleBody}>
                                <div className={style.articleDetails}>
                                    <div className={style.popupTitle}>
                                        <Title tag="h2" className="fontTeko">{data.name}</Title>
                                    </div>
                                    <div className={style.articleSubDetails}>
                                        <div className={style.iconList}>
                                            <div className={style.categoryRow}>
                                                {
                                                    author_name !== "" && author_name !== null && (
                                                        <IconLabel icon="User" label={author_name} />
                                                    )
                                                }
                                                <IconLabel icon="Calendar" label={formatDate(publish_date)} />
                                            </div>
                                        </div>
                                        <div className={style.iconList}>
                                            {
                                                (categories.length || []).length > 0 && (
                                                    <CategoryList type="category" item={categories} tag="p" />
                                                )
                                            }
                                            {
                                                (themes.length || []).length > 0 && (
                                                    <CategoryList item={themes} tag="p" />
                                                )
                                            }
                                            <ReadTime time={time_duration} />
                                            {
                                                (tags.length || []).length > 0 && (
                                                    <CategoryList item={tags} tag="p" />
                                                )
                                            }
                                        </div>
                                    </div>
                                    <div className={style.description}>
                                        <Editor text={data.short_description} />
                                    </div>
                                    {
                                        data.additional_resource_article !== null && get(data, "additional_resource_article", []).length > 0 && (
                                            <>
                                                <div className={`${style.readMoreReadLessContent} ${showAdditonalResources ? style.active : ''}`}>
                                                    <div onClick={() => { setShowAdditonalResources(prev => !prev) }} className={style.rmrlHeader}>
                                                        <div className={style.categoryList}>
                                                            <div className={style.categoryItemIcon}>
                                                                <div className={style.plus}>
                                                                    <span></span>
                                                                    <span></span>
                                                                </div>
                                                            </div>
                                                            <div className={style.categoryItem}>
                                                                <Title tag="p">Includes additonal resources</Title>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className={style.rmrlBody}>
                                                        <RelatedList list={data.additional_resource_article} />
                                                    </div>
                                                </div>
                                                <div className={style.buttonRow}>
                                                    <ArticleButton type={data.media_type} url={url} />
                                                    {
                                                        userProfile.id !== undefined && (
                                                            <ArticleSave id={data.id} />
                                                        )
                                                    }
                                                </div>
                                            </>
                                        )
                                    }
                                </div>
                            </div>
                            {
                                (data.related_article || []).length > 0 && (
                                    <div className={style.articleFooter}>
                                        <div className={style.popupSubTitle}>
                                            <Title tag="h4" className="fontTeko">Related content</Title>
                                        </div>
                                        <RelatedList list={data.related_article} />
                                    </div>
                                )
                            }
                        </div>
                    )
                }
            }}
        />
    )
}